export default function LeaveRedIcon() {
  return (
    <>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 6.75L6.75 9M6.75 9L9 11.25M6.75 9H15.75"
          stroke="#FF3838"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M11.25 5.625V5.625C11.25 3.76104 9.73896 2.25 7.875 2.25H6.25C4.04086 2.25 2.25 4.04086 2.25 6.25V11.75C2.25 13.9591 4.04086 15.75 6.25 15.75H7.875C9.73896 15.75 11.25 14.239 11.25 12.375V12.375"
          stroke="#FF3838"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
